import { render, staticRenderFns } from "./escolaridade.vue?vue&type=template&id=277bb692&scoped=true"
import script from "./escolaridade.vue?vue&type=script&lang=js"
export * from "./escolaridade.vue?vue&type=script&lang=js"
import style0 from "./escolaridade.vue?vue&type=style&index=0&id=277bb692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277bb692",
  null
  
)

export default component.exports